import { decodeJwt } from './jwt';

/** Extrae el email del credential JWT de Google (solo para mostrarlo; no se envía a ningún lado). */
export function getGoogleCredentialEmail(credential: string | undefined): string | null {
  if (!credential) return null;
  try {
    const email = decodeJwt(credential)?.email;
    return typeof email === 'string' && email ? email : null;
  } catch {
    return null;
  }
}

/** Mensaje "correo no registrado" incluyendo el correo que falló, si se pudo decodificar. */
export function buildGoogleNotRegisteredMessage(
  credential: string | undefined,
  template: string,
  fallback: string,
): string {
  const email = getGoogleCredentialEmail(credential);
  return email ? template.replace('{email}', email) : fallback;
}
